import { v4 as uuidv4 } from 'uuid';
import { fetchMedataDataFromFile, fetchMedataDataFromFileChunks } from "components/SubmissionForm/Form.api";
import { MessageReader } from 'EmailReader';
import { FileUploadStatus, ChunkSize, FileType } from './Constants';

export const cleanupFileName = fileName => {
  // fix for Issue 278155: Stuck Submissions
  // eslint-disable-next-line no-control-regex
  return fileName.replace(/[\u0000-\u001F\u007F\uFFFE\uFFFF\uFDD0-\uFDEF\uFFFD]/g, '');
}

export const parseMessage = (message, file) => {
  var reader = new MessageReader(message);
  var email = reader.getFileData();
  var attachments = email.attachments?.map(a => {
    return {
      id: uuidv4(),
      name: (a.innerMsgContent ? `${a.name}.msg` : a.name).replace(":", ""),
      mimeType: a.mimeType,
      isAttached: false,
      size: a.contentLength
    };
  });

  return {
    id: uuidv4(),
    type: FileType.message,
    content: message,
    messageFile: { name: file.name },
    title: email.subject,
    body: email.body,
    sender: email.senderEmail ? email.senderEmail : email.senderName,
    recipients: email.recipients.map(r => r.email ? r.email : r.name),
    attachments: attachments,
    upload: { status: FileUploadStatus.notStarted },
    file: file
  };
};

export const initDocument = (document, file) => {
  return {
    id: uuidv4(),
    type: FileType.document,
    content: document,
    upload: { status: FileUploadStatus.notStarted },
    file: file
  };
};

export const emlDocument = async (document, file, fetchCustomMetadata = async () => {}) => {
  let response = await fetchCustomMetadata();

  // Fallback to fetching metadata from the file directly if no metadata is provided
  if (!response?.data) {
    if (file.size < ChunkSize.chunk) {
      // If the file is small enough, fetch metadata directly from the file
      response = await fetchMedataDataFromFile(file, document);
    }
    else {
      // If the file is large, fetch metadata by chunks
      response = await getMetadataUploadByChunks(file);
    }
  }

  let email = response.data;

  return {
    id: uuidv4(),
    type: FileType.message,
    content: document,
    messageFile: { name: file.name },
    title: email.subject,
    body: email.body,
    sender: email.sender,
    recipients: email.recipients,
    attachments: email.attachments,
    upload: { status: FileUploadStatus.notStarted },
    file: file
  };
};

export const getMetadataUploadByChunks = async (document) => {
  const totalCount = Math.ceil(document.size / ChunkSize.chunk);
  let startOfChunk = 0;
  let endOfTheChunk = ChunkSize.chunk;
  let lastResponse = null;

  for (let i = 0; i < totalCount; i++) {
    const chunk = document.slice(startOfChunk, endOfTheChunk);
    const isLastChunk = i === totalCount - 1;
    const response = await fetchMedataDataFromFileChunks(document.name, isLastChunk, chunk);

    if (response.success) {
      console.log("%c Response #" + i, "background: pink; color: white", response);
      startOfChunk = endOfTheChunk;
      endOfTheChunk += ChunkSize.chunk;
      lastResponse = response; // Store the last successful response
    } else {
      throw response.error;
    }
  }

  return lastResponse;
}

export const uploadFileByChunks = async (document, uploadFile, onUpload, onUploadArguments) => {
  let file = document.file;
  let totalCount = Math.ceil(file.size / ChunkSize.chunk);
  let beginingOfTheChunk = 0;
  let endOfTheChunk = ChunkSize.chunk;
  let uploadPath = [];

  for (var i = 0; i < totalCount; i++) {
    let chunk = file.slice(beginingOfTheChunk, endOfTheChunk);

    let response = await uploadFile(document.file.name, chunk);
    if (response.success) {
      uploadPath.push(response.uploadPath);
      beginingOfTheChunk = endOfTheChunk;
      endOfTheChunk = endOfTheChunk + ChunkSize.chunk;
    } else {
      onUpload(onUploadArguments);
      throw response.error;
    }
  }

  onUploadArguments.uploadPath = uploadPath;
  onUpload(onUploadArguments);
}